import React from "react";
import { Stack, Box, Skeleton, Grid } from "@mui/material";

const SkeletonLoader = () => {
  return (
    <Grid container spacing={2}>
      {/* Skeleton for Appointment Details */}
      <Grid item xs={12} md={6}>
        <Box>
          <Skeleton variant="text" width="60%" height={30} />
          <Box
            p={2}
            border={"1px solid"}
            borderColor={"text.borderGrey"}
            borderRadius={1}
            mt={1}
          >
            {Array.from({ length: 6 }).map((_, index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                key={index}
                py={0.5}
              >
                <Skeleton variant="text" width="30%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Skeleton for Service Details */}
      <Grid item xs={12} md={6}>
        <Box>
          <Skeleton variant="text" width="60%" height={30} />
          <Box
            p={2}
            border={"1px solid"}
            borderColor={"text.borderGrey"}
            borderRadius={1}
            mt={1}
          >
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="70%" height={20} />
            <Skeleton variant="rectangular" width="100%" height={50} />
          </Box>
        </Box>
      </Grid>

      {/* Skeleton for Company Details */}
      <Grid item xs={12} md={6}>
        <Box>
          <Skeleton variant="text" width="60%" height={30} />
          <Box
            p={2}
            border={"1px solid"}
            borderColor={"text.borderGrey"}
            borderRadius={1}
            mt={1}
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Skeleton variant="circular" width={50} height={50} />
              <Skeleton variant="text" width="50%" height={30} />
            </Stack>
            {Array.from({ length: 3 }).map((_, index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                key={index}
                py={0.5}
              >
                <Skeleton variant="text" width="30%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Skeleton for Worker Details */}
      <Grid item xs={12} md={6}>
        <Box>
          <Skeleton variant="text" width="60%" height={30} />
          <Box
            p={2}
            border={"1px solid"}
            borderColor={"text.borderGrey"}
            borderRadius={1}
            mt={1}
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Skeleton variant="circular" width={50} height={50} />
              <Skeleton variant="text" width="50%" height={30} />
            </Stack>
            {Array.from({ length: 3 }).map((_, index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                key={index}
                py={0.5}
              >
                <Skeleton variant="text" width="30%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Skeleton for Shipping Address */}
      <Grid item xs={12} md={6}>
        <Box>
          <Skeleton variant="text" width="60%" height={30} />
          <Box
            p={2}
            border={"1px solid"}
            borderColor={"text.borderGrey"}
            borderRadius={1}
            mt={1}
          >
            {Array.from({ length: 7 }).map((_, index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                key={index}
                py={0.5}
              >
                <Skeleton variant="text" width="30%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>
            ))}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SkeletonLoader;
